export default "__VITE_ASSET__BLfn2VUN__"